(function () {
  function truncateText() {
    document.querySelectorAll('.product-short p span, .product-short p, .product-short').forEach(function (element) {
      if (element.textContent.length > 35) {
        element.textContent = element.textContent.substring(0, 35) + '...';
      }
    });
  }

  function isMobileView() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function scrollActiveTabButton(wrapEl, tabs, activeIndex, isInitial) {
    if (!isMobileView() || !wrapEl || !tabs.length) {
      return;
    }

    var maxScrollLeft = wrapEl.scrollWidth - wrapEl.clientWidth;
    if (maxScrollLeft <= 0) {
      return;
    }

    var targetScrollLeft;
    if (activeIndex === 0) {
      targetScrollLeft = 0;
    } else if (activeIndex === tabs.length - 1) {
      targetScrollLeft = maxScrollLeft;
    } else {
      var activeTab = tabs[activeIndex];
      var activeLeft = activeTab.offsetLeft - wrapEl.offsetLeft + wrapEl.scrollLeft;
      targetScrollLeft = activeLeft - (wrapEl.clientWidth - activeTab.offsetWidth) / 2;
      targetScrollLeft = Math.max(0, Math.min(targetScrollLeft, maxScrollLeft));
    }

    wrapEl.scrollTo({
      left: targetScrollLeft,
      behavior: isInitial ? 'auto' : 'smooth'
    });
  }

  function mountDeferredTabPanel(panel) {
    var templateId = panel.getAttribute('data-drf-tab-template');
    if (!templateId || panel.dataset.drfMounted === 'true') {
      return;
    }

    var template = document.getElementById(templateId);
    if (!template || !template.content) {
      return;
    }

    panel.appendChild(template.content.cloneNode(true));
    panel.dataset.drfMounted = 'true';
    initProductHoverImages();
    if (window.MeeoowSlider && typeof window.MeeoowSlider.init === 'function') {
      window.MeeoowSlider.init(panel);
    }

    if (typeof window.FP_rerunSwipers === 'function') {
      window.FP_rerunSwipers();
    }
  }

  function initGenericTabs() {
    document.querySelectorAll('.shopify-section.index-section.Multi-Collection').forEach(function (section) {
      var tabBtnWrap = section.querySelector('.tab-btn');
      var tabs = tabBtnWrap ? tabBtnWrap.querySelectorAll('.tablink') : [];
      var contents = section.querySelectorAll('.tabs-content .tabcontent');

      if (!tabs.length || !contents.length) {
        return;
      }

      function setActiveTab(index, isInitial) {
        tabs.forEach(function (tab, tabIndex) {
          tab.classList.toggle('active', tabIndex === index);
        });
        contents.forEach(function (content, contentIndex) {
          var isActive = contentIndex === index;
          content.classList.toggle('active', isActive);
          if (isActive) {
            mountDeferredTabPanel(content);
          }
        });
        scrollActiveTabButton(tabBtnWrap, tabs, index, isInitial);
      }

      setActiveTab(0, true);

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
          setActiveTab(index, false);
        });
      });
    });
  }

  function initMultiCollection2() {
    document.querySelectorAll('.shopify-section.index-section.Multi-Collection2').forEach(function (section) {
      var tabs = section.querySelectorAll('.tab-btn .tablinks');
      var contents = section.querySelectorAll('.tabs-content .tabcontents');
      var tabBtnWrap = section.querySelector('.tab-btn');

      if (!tabs.length || !contents.length) {
        return;
      }

      var startX = 0;

      function setActiveTab(index, isInitial) {
        tabs.forEach(function (tab, tabIndex) {
          tab.classList.toggle('active', tabIndex === index);
        });
        contents.forEach(function (content, contentIndex) {
          var isActive = contentIndex === index;
          content.classList.toggle('active', isActive);
          if (isActive) {
            mountDeferredTabPanel(content);
          }
        });
        scrollActiveTabButton(tabBtnWrap, tabs, index, isInitial);
      }

      setActiveTab(0, true);

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
          setActiveTab(index, false);
        });
      });

      var tabsContent = section.querySelector('.tabs-content');
      if (!tabsContent) {
        return;
      }

      tabsContent.addEventListener('touchstart', function (event) {
        startX = event.touches[0].clientX;
      }, { passive: true });

      tabsContent.addEventListener('touchend', function (event) {
        var endX = event.changedTouches[0].clientX;
        var diff = startX - endX;
        var activeIndex = Array.prototype.findIndex.call(tabs, function (tab) {
          return tab.classList.contains('active');
        });

        if (diff > 50 && activeIndex < tabs.length - 1) {
          setActiveTab(activeIndex + 1, false);
        }

        if (diff < -50 && activeIndex > 0) {
          setActiveTab(activeIndex - 1, false);
        }
      }, { passive: true });
    });
  }

  function initProductHoverImages() {
    document.querySelectorAll('img.custom_hover_second_image_bs_ss[data-hover-src]').forEach(function (img) {
      if (img.closest('.product-card__media')) {
        return;
      }

      var wrap = img.closest('.imagge-wrap');
      if (!wrap || img.dataset.hoverBound === 'true') {
        return;
      }

      img.dataset.hoverBound = 'true';

      function loadHoverImage() {
        if (img.dataset.hoverLoaded === 'true') {
          return;
        }

        img.src = img.getAttribute('data-hover-src');
        var hoverSrcset = img.getAttribute('data-hover-srcset');
        var hoverSizes = img.getAttribute('data-hover-sizes');

        if (hoverSrcset) {
          img.srcset = hoverSrcset;
        }
        if (hoverSizes) {
          img.sizes = hoverSizes;
        }

        img.dataset.hoverLoaded = 'true';
      }

      wrap.addEventListener('mouseenter', loadHoverImage, { once: true });
      wrap.addEventListener('focusin', loadHoverImage, { once: true });
    });
  }

  function boot() {
    truncateText();

    var truncateTargets = document.querySelectorAll('.product-short');
    if (truncateTargets.length && typeof MutationObserver !== 'undefined') {
      var observer = new MutationObserver(truncateText);
      truncateTargets.forEach(function (el) {
        observer.observe(el, { childList: true, subtree: true, characterData: true });
      });
    }

    initGenericTabs();
    initMultiCollection2();
    initProductHoverImages();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
